import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GitBranchNameDisplayComponent } from './git-branch-name-display.component';

@NgModule({
  declarations: [GitBranchNameDisplayComponent],
  exports: [GitBranchNameDisplayComponent],
  imports: [CommonModule, FontAwesomeModule],
})
export class GitBranchNameDisplayModule {}
